import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  EmailNotificationRecipient,
  GetEmailRecipientsParams
} from "../../emailNotifications.types";
import { requestGetEmailRecipients } from "./getEmailRecipients.request";

const useGetEmailRecipients = (
  params: GetEmailRecipientsParams,
  options?: QueryOptions<
    EmailNotificationRecipient[],
    ApiServiceError<ApiError>
  >
) => {
  const { data: recipients, ...rest } = useQuery({
    queryKey: ["email-notifications", "recipients", params],
    queryFn: async () => await requestGetEmailRecipients(params),
    onError: toastServerError,
    ...options
  });

  return { recipients, ...rest };
};

export default useGetEmailRecipients;
